export type ApprovalLevelKind = "business" | "technical" | "sales";

export const APPROVAL_KIND_OPTIONS: {
  value: ApprovalLevelKind;
  label: string;
}[] = [
  { value: "technical", label: "Technical" },
  { value: "sales", label: "Sales" },
  { value: "business", label: "Business" },
];

export type ApprovalMeasure =
  | "contract_cost"
  | "contract_revenue"
  | "contract_margin"
  | "contract_profit"
  | "customized_services"
  | "customized_terms"
  | "net_mrr"
  | "ps_margin"
  | "ms_margin"
  | "payment_credit_amount"
  | "third_party_margin"
  | "third_party_revenue"
  | "total_effort"
  | "business_unit_id";

export type ApprovalEvaluation =
  | "greater_than"
  | "equal_to"
  | "less_than"
  | "between";

export interface ApprovalTrigger {
  id?: number;
  measure: ApprovalMeasure | "";
  evaluation: ApprovalEvaluation | "";
  comparison_value: string;
  maximum_value: number | null;
}

export interface ApprovalLevelApprover {
  // Persisted rows have a numeric server id (stored as string).
  // New rows have a client-only id like "new-1" — wire serialization drops it.
  id?: string;
  userId: string;
  name: string;
  required: boolean;
  lobIds: string[];
}

export interface ApprovalLevelRow {
  id: string;
  position: number;
  name: string;
  kind: ApprovalLevelKind;
  signaturesRequired: number;
  submitterMayApprove: boolean;
  limitApprovalsToTeam: boolean;
  triggers: ApprovalTrigger[];
  triggerDescription: string;
  approvers: ApprovalLevelApprover[];
  deletedAt: string | null;
}

export interface ApprovalLevelFormValues {
  name: string;
  kind: ApprovalLevelKind;
  signaturesRequired: number;
  submitterMayApprove: boolean;
  limitApprovalsToTeam: boolean;
  triggers: ApprovalTrigger[];
  approvers: ApprovalLevelApprover[];
}
